import {Pipe, PipeTransform} from '@angular/core';
import {faBed, faCar, faFolder, faPlane, faQuestion, IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {TComputeValueInput} from "libraries/pipes/configurable-table/compute-value.pipe";
import {IGetBookingsCommonResponse} from "../../service/resources/booking/interfaces/IGetBookings";
import {BookingService} from "../../service/booking/booking.service";

@Pipe({
    name: 'bookingIcon'
})
export class BookingIcon implements PipeTransform {

    public plane: IconDefinition = faPlane;
    public folder: IconDefinition = faFolder;
    public bed: IconDefinition = faBed;
    public car: IconDefinition = faCar;
    public notFound: IconDefinition = faQuestion;

    constructor(
        private readonly bookingService: BookingService
    ) {
    }

    transform(booking: TComputeValueInput): IconDefinition {
        if (booking) {
            if (this.isAirBooking(booking as IGetBookingsCommonResponse)) {
                return this.plane;
            }
            if (this.isHotelBooking(booking as IGetBookingsCommonResponse)) {
                return this.bed;
            }
            if (this.isVehicleRentalBooking(booking as IGetBookingsCommonResponse)) {
                return this.car;
            }
            return this.folder;
        }
        return this.notFound;
    }

    public isAirBooking(booking: TComputeValueInput): boolean {
        return this.bookingService.isAirBooking(booking as IGetBookingsCommonResponse);
    }

    public isHotelBooking(booking: TComputeValueInput): boolean {
        return this.bookingService.isHotelBooking(booking as IGetBookingsCommonResponse);
    }

    public isVehicleRentalBooking(booking: TComputeValueInput): boolean {
        return this.bookingService.isVehicleRentalBooking(booking as IGetBookingsCommonResponse);
    }
}
